import styled from 'styled-components';
import { styleVariables } from '../../../common/constants';

const HeroBannerRootElement = styled.div`
    width:100%;
    @media (max-width: 991px) {
      background-position: 66% 0;
    }
    .intro{
      padding: 48px 0;
      .title-sub {
        margin: 0px !important;
        @media (max-width: 767px) {
          padding-top: 5px;
        }
      }
      @media (max-width: 767px) {
        padding: 36px 0;
        h1{
          font-size: 1.5rem;
        }
      }
    }
    .bar{
      background-color: #f9f9f9;
      height: 56px;
      align-content: center;
      @media (max-width: 767px) {
        background-color: #0A0A0A;
        }
    }
    .bar-title{
      color: ${styleVariables.background} !important;
    }
`;
export default HeroBannerRootElement;

export const SecondaryNavRootElement = styled.div`
    .hide {
      display: none;
    }
    .top-navigation {
      max-width: 90em;
      min-width: 20em;
      margin: 0 auto;
      .top-nav-title {
        @media only screen and (min-width: 40.063em) {
          width: auto;
        }
        display: table;
        width: 100%;

        .bar-title {
          width: 85%;
          display: table-cell;
          padding: 1em 26px 1em 1em;
        }
        .nav-toggle {
          display: table-cell;
          padding: .7em 0;
          text-align: center;
          svg {
            vertical-align: middle;
          }
          @media only screen and (min-width: 40.063em) {
            display: none;
          }
        }
      }
      .menu-links {
        max-width: unset;
        align-items: flex-start;
        .menu-item {
          text-decoration: none !important;
          .desktop-caret-down {
            @media only screen and (max-width: 40.063em) {
              display: none;
            }
          }
          .mobile-caret-down {
            margin-right: 5px;
            @media only screen and (min-width: 40.063em) {
              display: none;
            }
          }
          &:hover {
            background-color: #00000008;
          }
        }
      }
    }
    width:100%;
    background-color: #fff;
    border-bottom: 1px solid #dedede;
    .secnavigation-head{
      @media only screen and (min-width: 40.063em) {
        display: flex;
      }
      align-items: center;
      .MuiTab-textColorPrimary {
        text-transform: uppercase;
        color: #000;
        font-size: 0.875rem;
      }
    }
    .nav-head {
      color: #000 !important;
      font-family: ArtifaktLegend;
      font-size: 0.875rem;
      font-weight: 700;
      padding: .7em 26px .7em 1em;
      @media (max-width: 767px) {
          white-space: nowrap;
          padding-left: 0;
          padding-right: 0;
          margin-right: 15px;
      }
    }
    
    .sectabcls {
      display: none;
      flex-flow: column wrap;
      &.show {
        display: flex;
      }
      @media only screen and (min-width: 40.063em) {
      display: flex;
        flex-flow: row wrap;
      }
      .MuiTabs-scroller  {
        @media (max-width: 767px) {
          overflow: auto !important;
        }
      }
    }
      
    .navmenucls ul {
      min-width: 13em;
      box-shadow: none;
      list-style: none;
      position: absolute;
      top: 1;
      left: 0;
      padding: 1rem 0;
      @media only screen and (min-width: 40.063em) {
        border: .0625rem solid #bfbfbf;
        border-bottom-width: .125rem;
        border-radius: 0 0 8px 8px;
        background: #fff;
      }
      @media only screen and (max-width: 40.063em) {
        position: relative;
        padding: 0 0 0 2rem;
        background: #00000008;
      }
        li {
          &:hover {
            background-color: #00000008;
          }
          a {
              font-size: 0.875rem;
              color: #000 !important;
              padding: 10px 0;
              margin: 0 16px;
              display: block;
              text-transform: none;
              text-decoration: none !important;
              font-weight: 600;
          }
        }
      }
    }
`;
